import { ECompetitorsPromotionType, ICompetitorService } from '../../../../../../../../reducers/v2';

/**
 * Возвращает список конкуренций для отображения в UI
 * Если в списке конкуренций есть объявления с topWithBet, то показываем все уровни, иначе показываем только top или topWithBet
 */
export const getCompetitorsList = (
  competitors: ICompetitorService[],
  betMoreThanTop: boolean,
): ICompetitorService[] => {
  const hasCompetitorsWithBet = competitors.some(
    ({ promotionType, amount }) => promotionType === ECompetitorsPromotionType.topWithBet && amount > 0,
  );

  if (hasCompetitorsWithBet) {
    return competitors;
  }

  return competitors.filter(({ promotionType }: ICompetitorService) => {
    if (promotionType !== ECompetitorsPromotionType.top && promotionType !== ECompetitorsPromotionType.topWithBet) {
      return true;
    }

    return promotionType === ECompetitorsPromotionType.top ? !betMoreThanTop : betMoreThanTop;
  });
};
